import { useState } from 'react';
import { api } from '../data/api';

export function LoginScreen() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const addr = email.trim();
    if (!addr) return;
    setBusy(true);
    try {
      await api.requestMagicLink(addr);
      setSent(true);
    } catch {
      // Same UX whether or not the email maps to an account — no enumeration.
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-brand">
          Risma <em>studio</em> · Console
        </div>
        {sent ? (
          <>
            <h1>
              Controlla l’<em>email</em>.
            </h1>
            <p>
              Se <b>{email}</b> è un account autorizzato, ti abbiamo inviato un link di accesso. Funziona una sola volta
              e scade tra 15 minuti.
            </p>
            <button type="button" className="btn btn-ghost" onClick={() => setSent(false)}>
              Usa un’altra email
            </button>
          </>
        ) : (
          <form onSubmit={submit}>
            <h1>
              Accedi alla <em>Console</em>.
            </h1>
            <p>Inserisci la tua email: ti invieremo un link di accesso.</p>
            <input
              className="input"
              type="email"
              placeholder="tu@rismastudio.it"
              value={email}
              autoFocus
              required
              onChange={(e) => setEmail(e.target.value)}
              style={{ marginBottom: 14 }}
            />
            <button type="submit" className="btn btn-primary" disabled={busy || !email.trim()}>
              {busy ? 'Invio…' : 'Invia link di accesso'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
